// extracted by mini-css-extract-plugin
export var content = "_ca-3";
export var list = "_ca-4";
export var settingsContent = "_ca-7";
export var settingsPanel = "_ca-8";
export var state = "_ca-6";
export var triggerBadge = "_ca-2";
export var triggerButton = "_ca-1";
export var triggerShell = "_ca-0";
export var unreadDot = "_ca-5";